import React from "react";
import { ManageEmploymentStatusContainer } from "../../containers";

const ManageEmploymentStatus = (props) => {
  return <ManageEmploymentStatusContainer {...props} />;
};

export default ManageEmploymentStatus;
